"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.getElement = getElement;
exports.getElementParentDimensions = getElementParentDimensions;
exports.getElementPosition = getElementPosition;
exports.getElementProgress = getElementProgress;
exports.getViewPortDimensions = getViewPortDimensions;

var _canUseDOM = _interopRequireDefault(require("./canUseDOM"));

var _isDOM = _interopRequireDefault(require("./isDOM"));

function getElement(element) {
  let targetMultiple = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (_canUseDOM.default && !!element) {
    if ((0, _isDOM.default)(element)) {
      return element;
    }

    if (targetMultiple) {
      return Array.from(document.querySelectorAll(element));
    }

    return [document.querySelector(element)];
  }

  return null;
}

function getElementPosition(element) {
  if (_canUseDOM.default) {
    return getElement(element)[0].getBoundingClientRect();
  }

  return null;
}

function getElementProgress(element) {
  let reverse = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (_canUseDOM.default) {
    const targetParent = getViewPortDimensions();
    const target = getElementPosition(element);
    const percentage = Math.round(target.top / targetParent.height * 100) / 100;
    return 1 <= percentage ? -1 : 0 >= percentage ? -1 : reverse ? percentage : 1 - percentage;
  }

  return null;
}

function getElementParentDimensions(element) {
  if (_canUseDOM.default) {
    const parent = getElement(element).parentElement;
    return {
      height: parent.offsetHeight,
      width: parent.offsetWidth
    };
  }

  return null;
}

function getViewPortDimensions() {
  if (_canUseDOM.default) {
    return {
      height: window.innerHeight,
      width: window.innerWidth
    };
  }

  return null;
}

var _default = getElement;
exports.default = _default;